import { useTranslation } from "react-i18next";
import { cn } from "@/shared/lib/utils";

interface CatalogStatusBadgeProps {
  readonly active: boolean;
  readonly testId?: string;
}

export function CatalogStatusBadge({ active, testId }: CatalogStatusBadgeProps) {
  const { t } = useTranslation();
  return (
    <span
      data-testid={testId}
      className={cn(
        "inline-flex items-center rounded-full px-2 py-0.5 font-sans text-xs font-medium",
        active ? "bg-emerald-100 text-emerald-800" : "bg-muted text-muted-foreground",
      )}
    >
      {active ? t("catalog.status.active") : t("catalog.status.archived")}
    </span>
  );
}
